import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
import { isEmpty } from '@ember/utils';
export default ItemsV3Serializer.extend({
  attrs: {
    itemOptions: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    comboSlots: {
      serialize: 'ids',
      deserialize: 'ids'
    }
  },
  keyForRelationship(key, type) {
    return this._super(key, type);
  },
  normalize(type, data) {
    // TODO: Ember data does not overwrite keys when they are missing from the response
    data.menu_category_id = data.menu_category_id ?? null;
    return this._super(type, data);
  },
  serialize(snapshot) {
    const serialized = this._super(snapshot);

    // backend returns an error if sort_name = "", it prefers that we don't include the key at all
    if (isEmpty(serialized.sort_name)) {
      delete serialized.sort_name;
    }
    return serialized;
  }
});